// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4ic-T","buttons":"styles_buttons__2y4Al"};